import { __extends } from "tslib";
import { SpeedIcon } from './speed-icon';
import { Popover } from '../../primitives/popover/popover';
import * as React from 'react';
import * as classNames from 'classnames';
var PlaybackRate = /** @class */ (function (_super) {
    __extends(PlaybackRate, _super);
    function PlaybackRate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false
        };
        _this.playbackRateOptions = [0.75, 1, 1.25, 1.5, 2, 2.5, 3];
        _this.getPlaybackItems = function () {
            return _this.playbackRateOptions.map(function (rate) {
                var onClickRate = function () {
                    _this.props.onSelect(rate);
                    _this.closePlaybackRateSelect();
                };
                return (React.createElement("div", { className: classNames('play-rate-item', { selected: _this.props.currentRate === rate }), onClick: onClickRate, key: rate },
                    React.createElement(SpeedIcon, null),
                    rate.toFixed(2)));
            });
        };
        _this.openPlaybackRateSelect = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };
        _this.closePlaybackRateSelect = function () {
            _this.setState({ isOpen: false });
        };
        return _this;
    }
    PlaybackRate.prototype.render = function () {
        var classnames = classNames('play-rate', { open: this.state.isOpen });
        return (React.createElement("div", { className: 'play-rate-container' },
            React.createElement(Popover, { onOuterAction: this.closePlaybackRateSelect, isOpen: this.state.isOpen, body: this.getPlaybackItems() },
                React.createElement("div", { onClick: this.openPlaybackRateSelect, className: classnames },
                    React.createElement(SpeedIcon, null),
                    this.props.currentRate.toFixed(2)))));
    };
    return PlaybackRate;
}(React.Component));
export { PlaybackRate };
//# sourceMappingURL=playback-rate.js.map